var addressAutocomplete = {
  options: {
    // global options
  },

  selectors: {
    "adress_components_section": ".js-my-offers-edit-adress-components-section",
    "input_address": "input[name='accomodation_adress']",
    "input_street": "input[name='accomodation_street']",
    "input_street_number": "input[name='accomodation_street_number']",
    "input_city": "input[name='accomodation_city']",
    "input_region": "input[name='accomodation_region']",
    "input_zipcode": "input[name='accomodation_zipcode']",
    "input_lat": "input[name='accomodation_lat']",
    "input_lng": "input[name='accomodation_lng']",

    "input_google_place_id": "input[name='accomodation_google_place_id']",

    "disabled_countries_alert": ".js-adress-autocomplete-disabled-countries-alert",
  },

  init: function () {
    const self = this;

    //check
    if (jQuery(self.selectors.input_address).length == 0) {
      return;
    }

    self.initAutocomplete();
  },

  initAutocomplete: function () {
    const self = this;

    const addressField = document.querySelector(self.selectors.input_address);

    window.autocomplete = new google.maps.places.Autocomplete(addressField, {
      fields: ["address_components", "geometry"],
      types: ["address"],
    });
    // When the user selects an address from the drop-down, populate the
    // address fields in the form.
    window.autocomplete.addListener("place_changed", self.fillInAddress);

    //Add validity html error message
    if (!jQuery(self.selectors.adress_components_section).hasClass("show")) {
      addressField.setCustomValidity(addressField.dataset.messageWrong);
    }

    const addressField2 = document.querySelector(self.selectors.input_google_place_id);

    window.autocomplete_place_id = new google.maps.places.Autocomplete(addressField2, {
      types: ['establishment'],
    });

    window.autocomplete_place_id.addListener("place_changed", self.fillPlaceId);
  },

  fillInAddress: function () {
    const self = addressAutocomplete;
    const place = window.autocomplete.getPlace();

    jQuery(self.selectors.disabled_countries_alert).removeClass("show"); //hide alert message

    let address = "";
    let street_number = "";
    let postcode = "";
    let city = "";
    let region = "";
    let administrative_area_level_1 = "";
    let administrative_area_level_2 = "";
    let locality = "";
    let country = "";

    if (!place.geometry) {
      console.log("No details available for input: '" + place.name + "'");
      return;
    }

    for (const component of place.address_components) {
      console.log(component);
      const componentType = component.types[0];

      switch (componentType) {

        case "route": {
          address = component.short_name;
          break;
        }

        case "street_number": {
          street_number = component.long_name;
          break;
        }

        case "premise": {
          street_number = component.long_name + (street_number !== '' ? '/' + street_number : '');
          break;
        }

        case "postal_code": {
          postcode = `${component.long_name}${postcode}`;
          break;
        }

        case "postal_code_suffix": {
          postcode = `${postcode}-${component.long_name}`;
          break;
        }

        case "administrative_area_level_1": {
          administrative_area_level_1 = component.short_name;
          break;
        }

        case "administrative_area_level_2": {
          administrative_area_level_2 = component.short_name;
          break;
        }

        case "locality":
          locality = component.long_name;
          break;

        case "country":
          country = component.long_name;
          break;
      }
    }

    if (country === "Česko" || country === "Slovensko") {
      //show message with information about banned countries
      jQuery(self.selectors.disabled_countries_alert).addClass("show");
      return;
    }

    if (locality !== "") {
      city = locality;
    } else if (administrative_area_level_2 !== "") {
      city = administrative_area_level_2;
    } else {
      city = administrative_area_level_1;
    }

    if (administrative_area_level_1 !== "") {
      region = administrative_area_level_1;
    }

    //Fill into form
    jQuery(self.selectors.input_street).val(address).trigger("input");
    jQuery(self.selectors.input_street_number).val(street_number).trigger("input");
    jQuery(self.selectors.input_city).val(city).trigger("input");
    jQuery(self.selectors.input_region).val(region).trigger("input");
    jQuery(self.selectors.input_zipcode).val(postcode).trigger("input");
    //jQuery("#input_zeme").val(country);
    jQuery(self.selectors.input_lat).val(place.geometry.location.lat()).trigger("input");
    jQuery(self.selectors.input_lng).val(place.geometry.location.lng()).trigger("input");

    //Show inputs
    jQuery(self.selectors.adress_components_section).addClass("show");

    //Unset html validity
    jQuery(self.selectors.input_address)[0].setCustomValidity('');
  },

  fillPlaceId: function () {
    const self = addressAutocomplete;

    const place = window.autocomplete_place_id.getPlace();
    console.log(place);
    if (place.place_id) {
      // Display the Place ID
      jQuery(self.selectors.input_google_place_id).val(place.place_id).trigger("input");
    }
  }
}

export { addressAutocomplete };